import { createStore, createHook } from 'react-sweet-state';

interface GeneratedTitleState {
	generatedTitle: string;
	trackAIResultViewStored: (attribute: any) => void;
}

const initialState: GeneratedTitleState = {
	generatedTitle: '',
	trackAIResultViewStored: () => {},
};

const NAME = 'GENERATED_TITLE_STORE';

const GeneratedTitleStore = createStore({
	name: NAME,
	initialState,
	actions: {
		setGeneratedTitle:
			(newTitle: string) =>
			({ setState }) => {
				setState({ generatedTitle: newTitle });
			},
		setTrackAIResultViewStored:
			(trackAIResultViewHook: (attribute: any) => void) =>
			({ setState }) => {
				setState({ trackAIResultViewStored: trackAIResultViewHook });
			},
	},
});

export const useGeneratedTitle = createHook(GeneratedTitleStore);
